import { Button, Col, Dropdown, Form, Modal, Row } from 'react-bootstrap';
import LabelRequired from '../../../component/LabelRequired';
import { IBenhNhanV3CDHA } from '../../models/ModelsPhanHeCDHAVaTDCN';
import { ChangeEvent, useContext, useEffect, useRef, useState } from 'react';
import ModalDSMauKetQuaThucHien from '../../components/modals/ModalDSMauKetQuaThucHien';
import { toast } from 'react-toastify';
import InfoPatientRight from '../../../phan-he-kham-benh/components/InfoPatientRight';
import TextField from '../../../component/TextField';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { AppContext } from '../../../appContext/AppContext';
import {
	convertFileToHTML,
	deleteRispacImage,
	getObsValue,
	saveMauKetQuaCDHA,
	uploadRispacImage,
} from '../../services/PhanHeCDHAVaTDCNService';
import { CODE, FILE_EXTENSION, RESPONSE_MESSAGE } from '../../../utils/Constant';
import WebcamCapture from '../../../component/webcam-image/WebcamCapture';
import { asBlob } from 'html-docx-js-typescript';
import { saveAs } from 'file-saver';
import NhapKetQuaCDHAEditor from './NhapKetQuaCDHAEditor';
import { TYPE_SAVE_CDHA } from '../../constants/Constants';
import ModalLuuMauKetQua from './ModalLuuMauKetQua';
import { base64ImageToBlob, formatDateDTO, getErrorMessage, getMimeTypeFromBase64 } from '../../../utils/FormatUtils';
import moment from 'moment';
import DatePickerCustom from '../../../component/date-picker/DatePickerCustom';
import ImageList from '../../../component/image-list';
import { getObsComplexCategories } from '../../../phan-he-danh-muc/DanhMucServices';
import AutocompleteV2 from '../../../component/AutocompleteObjectV2';
import { TERM_MODEL_TYPE } from '../../../phan-he-danh-muc/const/constant';

type Props = {
	handleClose: () => void;
	handleTraKetQua: () => void;
	infoBenhNhan?: IBenhNhanV3CDHA;
	isViewModal?: boolean;
	workFlowStatus?: any;
	handleSubmitForm: (values: any) => void;
	resultData?: any;
	selectedRow?: any;
};

type UploadType = {
	code: string;
	extension: string;
};

const FILE_UPLOAD_TYPE: Record<'DOC' | 'IMAGE', UploadType> = {
	DOC: {
		code: 'DOC',
		extension: '.doc, .docx',
	},
	IMAGE: {
		code: 'IMAGE',
		extension: 'image/*',
	},
};

export default function ModalThucHienCDHA({
	handleClose,
	infoBenhNhan,
	isViewModal,
	handleSubmitForm,
	resultData,
	selectedRow,
}: Props) {
	const { setIsLoading } = useContext(AppContext);

	const [inforResult, setInforResult] = useState<any>({});
	const [openWebcamCapture, setOpenWebcamCapture] = useState<boolean>();
	const [images, setImages] = useState<any[]>([]);
	const [noiDungMauKetQua, setNoiDungMauKetQua] = useState<string>('');
	const [openLuuMauKetQuaDialog, setOpenLuuMauKetQuaDialog] = useState<boolean>(false);
	const [openDanhSachMauKetQuaDialog, setOpenDanhSachMauKetQuaDialog] = useState(false);

	const refForm = useRef<any>();
	const uploadFileRef = useRef<HTMLInputElement>(null);
	const importFilenameRef = useRef<string>('');
	const mauKetQuaSelectedRef = useRef<any>();
	const imagesRef = useRef<any[]>([]);

	const initialValues: any = {};

	const validationSchema = Yup.object({});

	useEffect(() => {
		if (resultData) {
			let mayThucHien = resultData?.executingMachine ? {
				tbDeviceCode: resultData?.executingMachineCode,
				tbDeviceName: resultData?.executingMachine
			} : null;
			setInforResult({
				...resultData,
				mayThucHien
			});
			if (resultData?.result) {
				setNoiDungMauKetQua(resultData.result);
			}
		} else {
			handleGetResult();
		}
	}, []);

	useEffect(() => {
		if (!inforResult?.startTime && infoBenhNhan?.executionStartTime) {
			setInforResult({
				...inforResult,
				startTime: formatDateDTO(infoBenhNhan?.executionStartTime),
			});
		}
	}, [infoBenhNhan]);

	useEffect(() => {
	  imagesRef.current = images;
	}, [images]);

	const handleSelectMauKetQua = (mauKetQua: any) => {
		setOpenDanhSachMauKetQuaDialog(false);
		setNoiDungMauKetQua(mauKetQua);
		toast.success('Chọn mẫu kết quả thành công');
	};

	const handleGetResult = async () => {
		try {
			setIsLoading(true);
			const { data } = await getObsValue({
				orderId: selectedRow?.orderId || selectedRow?.obs?.orderId,
			});

			if (data?.code === CODE.SUCCESS) {
				let mayThucHien = data?.data?.executingMachine ? {
					tbDeviceCode: data?.data?.executingMachineCode,
					tbDeviceName: data?.data?.executingMachine
				} : null;
				if (!data?.data?.startTime && infoBenhNhan?.executionStartTime) {
					const startTime = formatDateDTO(infoBenhNhan?.executionStartTime || new Date());
					setInforResult({
						...data?.data,
						startTime,
						mayThucHien
					});
				} else {
					setInforResult({
						...data?.data,
						mayThucHien
					});
				}
				if (data?.data?.result) {
					setNoiDungMauKetQua(data?.data?.result);
				}
				
				if (data?.data?.files?.length) {
					setImages(
						data?.data?.files.map((file: any, index: number) => {
							if (file.url.includes('base64')) {
								const base64 = file.url.split('base64,')[1];
								const mimeType = getMimeTypeFromBase64(base64);
								const src = file.url.replace(
									'application/octet-stream',
									mimeType
								);
								return {
									...file,
									index,
									src,
									fileType: mimeType,
								};
							}

							return {
								...file,
								index,
								src: file.url,
							}
						})
					);
				}
			}
		} catch (error) {
			toast.error('Xảy ra lỗi, vui lòng thử lại!');
		} finally {
			setIsLoading(false);
		}
	};
	
	const handleChangeInfor = (value: any, name: string) => {
		setInforResult({
			...inforResult,
			[name]: value,
		});
	};

	const onImportFileKetQua = async (e: ChangeEvent<HTMLInputElement>) => {
		const fileUpload = e.target.files;

		if (!fileUpload?.length) return;

		const file = fileUpload[0];
		importFilenameRef.current = file.name;

		const formData = new FormData();
		formData.append('file', file);

		try {
			setIsLoading(true);
			const { code, data } = await convertFileToHTML(formData);

			if (code !== CODE.SUCCESS) {
				toast.error(RESPONSE_MESSAGE.ERROR);
				return;
			}

			setNoiDungMauKetQua(data);
			setOpenLuuMauKetQuaDialog(true);
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		} finally {
			setIsLoading(false);
		}
	};

	const onExportFileKetQua = async () => {
		try {
			if (noiDungMauKetQua) {
				const blobResult = (await asBlob(noiDungMauKetQua)) as Blob;
				saveAs(blobResult, importFilenameRef.current);
			}
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		}
	};

	const onLuuMauKetQua = async (value: any) => {
		try {
			const isUpdate = mauKetQuaSelectedRef.current?.id;

			const { code, data } = await saveMauKetQuaCDHA({
				id: mauKetQuaSelectedRef.current?.id ?? null,
				termId: infoBenhNhan?.orders[0].term.parentId,
				name: value.tenMauKetQua,
				content: noiDungMauKetQua,
			});

			if (CODE.SUCCESS !== code) {
				toast.error(data[0]?.errorMessage);
				return;
			}

			toast.success(
				isUpdate ? 'Cập nhật mẫu kết quả thành công' : 'Lưu mẫu kết quả thành công'
			);
			setOpenLuuMauKetQuaDialog(false);
			mauKetQuaSelectedRef.current = null;
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		}
	};

	const onFileChange = (e: ChangeEvent<HTMLInputElement>) => {
		if (!e.target.files) return;

		if (!validateFileUpload(e.target.files, e.target.name)) {
			toast.warn('Định dạng file không hợp lệ');
			return;
		}
		
		switch (e.target.name) {
			case FILE_UPLOAD_TYPE.DOC.code:
				onImportFileKetQua(e);
				break;

			case FILE_UPLOAD_TYPE.IMAGE.code:
				const files = e.target.files;
				if (files.length) {
					onUploadImage(files);
				}
				break;

			default:
				break;
		}

		e.target.value = '';
	};

	const validateFileUpload = (files: FileList, fileType: string) => {
		let isValid = true;
		const fileArray = Array.from(files);

		if (fileType === 'DOC') {
			isValid = fileArray.every(file => [FILE_EXTENSION.DOC, FILE_EXTENSION.DOCX].includes(file.type));
		}

		return isValid;
	};

	const onUploadButtonClick = (type: keyof typeof FILE_UPLOAD_TYPE) => {
		if (!uploadFileRef.current) return;

		switch (type) {
			case 'DOC':
				uploadFileRef.current.name = FILE_UPLOAD_TYPE.DOC.code;
				uploadFileRef.current.accept = FILE_UPLOAD_TYPE.DOC.extension;
				uploadFileRef.current.multiple = false;
				uploadFileRef.current.click();
				break;

			case 'IMAGE':
				uploadFileRef.current.name = FILE_UPLOAD_TYPE.IMAGE.code;
				uploadFileRef.current.multiple = true;
				uploadFileRef.current.accept = FILE_UPLOAD_TYPE.IMAGE.extension;
				uploadFileRef.current.click();
				break;

			default:
				break;
		}
	};

	const handleCountDate = () => {
		let startDate = moment(inforResult?.startTime);
		let endDate = moment(inforResult?.endTime ? inforResult?.endTime : new Date());

		let duration = moment.duration(endDate.diff(startDate));

		let days = Math.floor(duration.asDays());
		let hours = duration.hours();
		let minutes = duration.minutes();
		let seconds = duration.seconds();
		let minutesDifference = [];

		if (days > 0) minutesDifference.push(`${days} ngày`);
		if (hours > 0) minutesDifference.push(`${hours} giờ`);
		if (minutes > 0) minutesDifference.push(`${minutes} phút`);
		if (seconds > 0) minutesDifference.push(`${seconds} giây`);

		return minutesDifference.join(', ');
	};

	useEffect(() => {
		if (inforResult?.startTime && inforResult?.endTime) {
			setInforResult((prev: any) => ({
				...prev,
				executionTime: handleCountDate(),
			}));
		}
	}, [inforResult?.startTime, inforResult?.endTime]);

	const handleSubmitAll = (handleSubmit: any, typeSubmit: string) => {
		handleSubmit();
		if (!inforResult?.conclusion?.trim()) {
			toast.warn("Kết luận không được để trống");
			return;
		};
		let objectSubmit = {
			noiDungMauKetQua,
			startTime: formatDateDTO(inforResult?.startTime) || null,
			endTime:
				formatDateDTO(inforResult?.endTime ? inforResult?.endTime : new Date()) || null,
			executionTime: inforResult?.executionTime || null,
			minimumTime: inforResult?.minimumTime || null,
			conclusion: inforResult?.conclusion || null,
			actionType: typeSubmit,
			handleGetResult: handleGetResult,
			images: images,
			executingMachineCode: inforResult?.mayThucHien?.tbDeviceCode || null,
			executingMachine: inforResult?.mayThucHien?.tbDeviceName || null
		};

		handleSubmitForm(objectSubmit);
	};

	const onLuuMauKetQuaButtonClick = () => {
		if (!noiDungMauKetQua) {
			toast.warn('Chưa nhập nội dung mẫu kết quả');
			return;
		}
		setOpenLuuMauKetQuaDialog(true);
	};

	const getSuggestion = () => {
		const searchString = noiDungMauKetQua.toLowerCase();

		const stripHTMLValue = new DOMParser()
			.parseFromString(searchString, 'text/html')
			.body.textContent?.trim();

		if (!stripHTMLValue) return;

		const resultIndex = stripHTMLValue.lastIndexOf('kết luận');

		if (resultIndex === -1) {
			toast.warn('Không tìm thấy gợi ý kết quả');
			return;
		}
		
		const startResultIndex = stripHTMLValue.indexOf(':', resultIndex);
		const endResultIndex = stripHTMLValue.indexOf('.', startResultIndex);
		const result = stripHTMLValue.slice(startResultIndex + 1, endResultIndex + 1).trim();
		
		handleChangeInfor(result, 'conclusion');
	};

	const mapImageList = (data: any[], params?: any) => {
		return data.map((item, index) => ({
			...item,
			index,
			src: item.url || item.src,
			...params
		}));
	};

	const onPACClick = () => {
		if (!inforResult?.pacsResultLink) return;
		window.open(inforResult.pacsResultLink, '_blank');
	};

	const onUploadImage = async (fileList: FileList) => {
		try {
			const formData = new FormData();
			const files = Array.from(fileList);
			files.forEach((file) => {
				formData.append('files', file);
			});

			const { data } = await uploadRispacImage(
				selectedRow?.orderId || selectedRow?.obs?.orderId,
				formData,
			);

			const imageURIList = data?.map((item: any) => ({
				...item,
				src: item.url,
			}));
			const listTemp = mapImageList([...images, ...imageURIList]);
			setImages(listTemp);
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		}	
	};

	const onImageCrop = (base64Value: string) => {
		const imageCropBlob = base64ImageToBlob(base64Value);
		const imageCropFile = new File([imageCropBlob], 'image-crop.jpeg');
		const datatransfer = new DataTransfer();
		datatransfer.items.add(imageCropFile);
		onUploadImage(datatransfer.files);
	};

	const onImageDelete = async (selectedImage: any) => {
		try {
			const response = await deleteRispacImage(selectedImage.id);

			if (CODE.SUCCESS !== response.code) {
				toast.error(getErrorMessage(response));
				return;
			}

			toast.success(RESPONSE_MESSAGE.SUCCESS);
			setImages(images.filter((image) => image.id !== selectedImage.id));
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		}
	};

	return (
		<Modal
			show
			onHide={handleClose}
			size="xl"
			centered
			contentClassName="h-100"
			enforceFocus={false}
			className="modal-xl-bigger"
		>
			<Modal.Header className="p-4" closeButton>
				<Modal.Title>Kết quả chẩn đoán hình ảnh</Modal.Title>
			</Modal.Header>

			<Formik
				initialValues={initialValues}
				validationSchema={validationSchema}
				onSubmit={() => {}}
				innerRef={refForm}
			>
				{({ handleSubmit, errors, touched }) => (
					<Form className="bg-white h-100">
						<div className="border-bottom menu-button-cdha">
							<div className='flex gap-3 spaces'>
								{!isViewModal && (
									<>
										<input
											type="file"
											hidden
											ref={uploadFileRef}
											accept=".doc,.docx"
											onChange={onFileChange}
										/>
										<Dropdown className="dropdown-btn menu-icon">
											<Dropdown.Toggle className="btn-outline">
												<i className="bi bi-list m-0 p-0"></i>
											</Dropdown.Toggle>
											<Dropdown.Menu>
												<Dropdown.Item
													onClick={() => {
														onUploadButtonClick('DOC');
													}}
												>
													Nhập file kết quả
												</Dropdown.Item>
												<Dropdown.Item onClick={onExportFileKetQua}>
													Xuất file kết quả
												</Dropdown.Item>
												<Dropdown.Divider />
												<Dropdown.Item
													onClick={() => {
														onUploadButtonClick('IMAGE');
													}}
												>
													Lấy ảnh từ máy tính
												</Dropdown.Item>
												<Dropdown.Item>
													Lấy ảnh từ kết nối chẩn đoán hình ảnh
												</Dropdown.Item>
												<Dropdown.Divider />
												<Dropdown.Item>
													Cấu hình thư viện nhận ảnh
												</Dropdown.Item>
												<Dropdown.Item>
													Cấu hình tự động crop ảnh
												</Dropdown.Item>
												<Dropdown.Divider />
												<Dropdown.Item>Xuất raw kết quả</Dropdown.Item>
											</Dropdown.Menu>
										</Dropdown>
										<Button
											className="btn-fill"
											onClick={() => {
												setOpenDanhSachMauKetQuaDialog(true);
											}}
										>
											Mẫu kết quả
										</Button>
										<Button
											className="btn-fill"
											onClick={onLuuMauKetQuaButtonClick}
										>
											{mauKetQuaSelectedRef.current?.id
												? 'Cập nhật mẫu kết quả'
												: 'Lưu mẫu kết quả'}
										</Button>
										<Button
											className="btn-fill min-w-50px"
											onClick={(e: any) => {
												handleSubmitAll(
													handleSubmit,
													TYPE_SAVE_CDHA.SAVE_PRINT.code
												);
											}}
										>
											{TYPE_SAVE_CDHA.SAVE_PRINT.name}
										</Button>
										<Button
											className="btn-fill min-w-50px"
											onClick={() => setOpenWebcamCapture(true)}
										>
											Chụp ảnh
										</Button>
									</>
								)}
								<Button className="btn-fill spaces h-30" onClick={onPACClick}>PACS</Button>	
								<div className="text-break fw-500 py-2 px-5 text-end position-absolute top-0 bottom-0 end-0 spaces w-40">
									<InfoPatientRight benhNhanInfo={infoBenhNhan} />
								</div>
							</div>
						</div>
						<Modal.Body className="padding-3-20 spaces h-calc-120">
							<Row className="h-100">
								<Col xs={4} className="flex border">
									<div className="flex-item-start pt-5 spaces w-100">
										<Row>
											<Col xs={12}>
												<div className="label-input-group mt-3 d-flex">
													<DatePickerCustom
														label="Bắt đầu"
														name="startTime"
														labelClassName="spaces min-w-110 fw-bold"
														value={inforResult.startTime}
														setDateValue={date => {
															handleChangeInfor(
																date,
																'startTime'
															)
														}}
														mode="date-time"
														errors={errors?.startTime}
														touched={touched?.startTime}
														disabled={isViewModal}
													/>
												</div>
											</Col>
											<Col xs={12}>
												<div className="label-input-group mt-3 d-flex">
													<DatePickerCustom
														label="Kết thúc"
														name="endTime"
														labelClassName="spaces min-w-110 fw-bold"
														value={inforResult.endTime}
														setDateValue={date => {
															handleChangeInfor(
																date,
																'endTime'
															)
														}}
														mode="date-time"
														errors={errors?.endTime}
														touched={touched?.endTime}
														disabled={isViewModal}
													/>
												</div>
											</Col>
											<Col xs={12}>
												<div className="label-input-group mt-3 d-flex">
													<LabelRequired
														label="TG thực hiện"
														className="spaces min-w-110 fw-bold "
													/>
													<TextField
														className="input flex-1"
														name="executionTime"
														labelClassName="max-w-90px"
														type="text"
														value={
															inforResult?.executionTime
																? inforResult?.executionTime
																: ''
														}
														disabled={true}
														onChange={(e: any) =>
															handleChangeInfor(
																e.target.value,
																'executionTime'
															)
														}
													/>
												</div>
											</Col>
											<Col xs={12}>
												<div className="label-input-group mt-3 d-flex">
													<LabelRequired
														label="TG tối thiểu"
														className="spaces min-w-110 fw-bold"
													/>
													<TextField
														className="input flex-1"
														name="minimumTime"
														labelClassName="max-w-90px"
														type="text"
														value={inforResult?.minimumTime || ''}
														disabled={isViewModal}
														onChange={(e: any) =>
															handleChangeInfor(
																e.target.value,
																'minimumTime'
															)
														}
													/>
												</div>
											</Col>
											<Col xs={12}>
												<div className="label-input-group mt-3 d-flex">
													<LabelRequired
														label="Máy thực hiện"
														className="label fw-500 spaces min-w-110 fw-bold"
													/>
													<AutocompleteV2
														className="input flex-1"
														options={[]}
														searchFunction={getObsComplexCategories}
														searchObject={TERM_MODEL_TYPE.MD_THIET_BI}
														getOptionLabel={option => option?.tbDeviceName}
														urlData='data.data'
														value={inforResult?.mayThucHien}
														onChange={option => handleChangeInfor(option, 'mayThucHien')}
														name="mayThucHien"
														isDisabled={isViewModal}
													/>
												</div>
											</Col>
											<Col xs={12}>
												<ImageList
													data={images}
													className='spaces mt-8 overflow-auto max-h-300 pb-8'
													setData={(data: any) => {
														setImages(data);
													}}
													style={{
														display: 'grid',
														gridTemplateColumns: 'repeat(2, minmax(150px, 1fr))',
														gap: 8,
													}}
													onImageCrop={onImageCrop}
													onImageDelete={onImageDelete}
												/>		
											</Col>
										</Row>
									</div>
								</Col>
								<Col
									xs={8}
									className="pe-0"
								>
									<div className="space w-100 h-100 d-flex flex-column">
										<div 
											className="spaces"
											style={{
												flex: '1 1 auto',
											}}
										>
											<NhapKetQuaCDHAEditor
												value={noiDungMauKetQua}
												disabled={isViewModal}
												onEditorChange={(value: string, editor: any) => {
													setNoiDungMauKetQua(value);
												}}
												onBlur={(a:any) => {
													const content = a.target.getContent();
													setNoiDungMauKetQua(content);
												}}
												rispacOrder={selectedRow}
												onUploadImageSuccess={(fileUploadedData) => {
													setImages(mapImageList([...imagesRef.current, fileUploadedData]));
												}}
											/>
										</div>

										<div className='spaces h-60 pt-10'>
											<div className="d-flex align-items-center gap-3 mt-2">
												<LabelRequired
													isRequired
													label="Kết luận"
													className="label fw-500 spaces fw-bold min-w-50"
												/>
												<TextField
													className="input spaces flex-10"
													name="conclusion"
													labelClassName="max-w-90px"
													type="text"
													value={inforResult?.conclusion || ''}
													disabled={isViewModal}
													onChange={(e: any) =>
														handleChangeInfor(
															e.target.value,
															'conclusion'
														)
													}
												/>
												{!isViewModal && (
													<span className="spaces flex-2 d-flex gap-3">
														<Button
															className="btn-fill min-w-75px me-3"
															onClick={getSuggestion}
														>
															Gợi ý
														</Button>
														<Button 
															className="btn-danger min-w-75px" 
															onClick={() => {
																handleChangeInfor('', 'conclusion');
															}}
														>
															Xoá
														</Button>
													</span>
												)}
											</div>
										</div>
									</div>
								</Col>
							</Row>
						</Modal.Body>
					</Form>
				)}
			</Formik>

			{openDanhSachMauKetQuaDialog && (
				<ModalDSMauKetQuaThucHien
					selectMauKetQua={handleSelectMauKetQua}
					handleClose={() => {
						setOpenDanhSachMauKetQuaDialog(false);
					}}
					thongTinPhieu={{
						termId: infoBenhNhan?.orders[0].term.parentId,
					}}
					onEdit={(row: any) => {
						mauKetQuaSelectedRef.current = row;
						setNoiDungMauKetQua(row.content);
					}}
				/>
			)}

			{openWebcamCapture && (
				<WebcamCapture
					open={openWebcamCapture}
					handleClose={() => setOpenWebcamCapture(false)}
					imgSrcs={images}
					setImageSrcs={(images) => {
						const listTemp = mapImageList(images);
						setImages(listTemp);
					}}
				/>
			)}

			{openLuuMauKetQuaDialog && (
				<ModalLuuMauKetQua
					open={openLuuMauKetQuaDialog}
					onClose={() => setOpenLuuMauKetQuaDialog(false)}
					onSave={onLuuMauKetQua}
					tenMauKetQua={mauKetQuaSelectedRef.current?.name}
				/>
			)}
		</Modal>
	);
}
